import React from 'react';
interface AdvertorialHeaderProps {
  logo: string;
  headline: string;
  subheadline: string;
  heroImage: string;
}
export const AdvertorialHeader: React.FC<AdvertorialHeaderProps> = ({
  logo,
  headline,
  subheadline,
  heroImage
}) => {
  return <header className="flex flex-col w-full bg-blue-50" data-id="element-35">
      <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-36">
        <h1 className="text-3xl md:text-5xl font-bold text-blue-900 mb-4" data-id="element-37">
          {headline}
        </h1>
        <p className="text-xl md:text-2xl text-blue-700 mb-8" data-id="element-38">{subheadline}</p>
      </div>
      <div className="w-full flex justify-center px-4" data-id="element-39">
        <img src={heroImage} alt="Happy dog with LedLycka" className="max-w-4xl w-full h-64 md:h-96 object-cover rounded-lg" data-id="element-40" />
      </div>
      <div className="w-full flex justify-center px-4 mt-6" data-id="element-41">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oD121JcDZBvVUzbBw19YQC/aa249c07-8399-49b5-93db-24d395ea07e7.png" alt="Woman with sad dog" className="max-w-4xl w-full h-64 md:h-96 object-cover rounded-lg" data-id="element-42" />
      </div>
      <div className="container mx-auto px-4 py-8 md:py-12 max-w-4xl" data-id="element-43">
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-44">
          Ta en titt på de två bilderna ovan.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-45">
          Kan du gissa vilken hund som har ledproblem?
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-46">
          Det är lätt att anta att det är den äldre hunden som ligger ner.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-47">
          Men svaret är båda.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-48">
          Stelhet och ömma leder dyker inte bara upp senare i livet.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-49">
          De börjar ofta mycket tidigare — fast de flesta hundägare märker det
          inte förrän skadorna redan är gjorda.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-50">
          Det beror på att hundar är hårdkodade för att dölja smärta.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-51">
          Du hör ingen gnäll eller vin förrän värken blir outhärdlig.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-52">
          Istället anpassar de hur de rör sig och fortsätter så gott de kan.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-53">
          Men under ytan bryts deras leder ner.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-54">
          Och du kanske tittar på när det händer just nu.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-55">Resultatet?</p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-56">
          Din hund lider i tystnad i åratal — tillsammans med 1,1 MILJONER andra
          svenska hundar.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-57">
          Hundar som brukade springa till dörren när du kom hem... som hoppade
          upp i soffan varje kväll... som lekte med glöd i ögonen... börjar
          sakta försvinna bakom stelhet och smärta.
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-4" data-id="element-58">
          Men det finns ett sätt att få tillbaka hunden du minns — den glada,
          rörliga, lekfulla vännen som älskade varje steg.
        </p>
        <p className="text-lg md:text-xl text-gray-700 font-semibold" data-id="element-59">
          Först behöver du känna igen de avslöjande tecknen:
        </p>
      </div>
    </header>;
};